import styled from 'styled-components';

import { ButtonWithRef } from 'components/button';

export const StyledButton = styled(ButtonWithRef)`
  width: fit-content;
`;
